import styled from "@emotion/styled";
import {css} from "@emotion/react";
import {colors, fontSize, sizes} from "patient-ping-remedy/packages/theme";

export const Container = styled.div<{ inline?: boolean }>`
  margin: 0;
  padding: 0;

  ${({ inline }) => inline && css`
    display: inline-flex;
    margin-left: ${sizes.xSmall};
  `};
`;

export const ExpandMoreButtonStyled = styled.div<{ active: boolean, inline?: boolean, disabled?: boolean }>`
  display: inline-flex;
  word-break: break-word;
  gap: ${sizes.xSmall};
  background: none;
  border: none;
  font-size: ${fontSize.standard};
  margin: ${({ inline }) => inline ? 0 : `${sizes.xSmall} 0 0 0`};
  text-align: left;
  padding: 0;
  color: ${({ active, inline }) => inline
    ? (active ? colors.tertiary2 : colors.primary1)
    : (active ? colors.primary1 : colors.gray4)};

  ${({ disabled }) => !disabled && css`
    cursor: pointer;
    &:hover {
      color: ${colors.purple3};
    }
  `};
`;
